{
    "edit": "Redigera",
    "attachment": "Bilaga",
    "backToSmartform": "Tillbaka till Smartform",
    "predefined": "Fördefinierad",
    "library": "Bibliotek",
    "preview": "Förhandsgranska",
    "previewPDF": "Förhandsgranska PDF",
    "previewHTML": "Förhandsgranska HTML",
    "pdfPreview": "PDF Förhandsgranskning",
    "htmlPreview": "HTML Förhandsgranskning",
    "splitScreen": "Delad skärm",
    "singleScreen": "Enskild skärm",
    "refresh": "Uppdatera",
    "refreshWithLatest": "Uppdatera med senaste ändringarna",
    "refreshDisabled": "Det finns inga ändringar att uppdatera",
    "loading": "Laddar",
    "publish": "Publicera",
    "discard": "Makulera",
    "previous": "Föregående",
    "next": "Nästa",
    "ok": "OK",
    "cancel": "Avbryt",
    "delete": "Radera",
    "openMenu": "Öppna menyn",
    "retry": "Försök igen",
    "exit": "Avsluta",
    "reason": "Anledning",
    "moreoptions": "Fler alternativ",
    "pageBreak": "Sidbrytning",
    "addPageBreak": "Lägg till sidbrytning",
    "addPageBreakBefore": "Lägg till sidbrytning före",
    "addPageBreakAfter": "Lägg till sidbrytning efter",
    "removePageBreak": "Ta bort sidbrytning",
    "removePageBreakBefore": "Ta bort sidbrytning före",
    "removePageBreakAfter": "Ta bort sidbrytning efter",
    "blockHelpText": "Tryck Skift + F10 eller högerklicka för alternativ",
    "paste": "Klistra in",
    "selectenoption": "Välj ett alternativ",
    "none": "Ingen",
    "authentication": {
        "authenticationRequired": "Autentisering krävs",
        "forbidden": "Förbjudet",
        "authenticate": "Autentisera",
        "authenticateMessage": "Detta dokument är skyddat och kräver att användare autentiserar sig.",
        "authFailedMessage": "Om detta problem kvarstår, kontakta din systemadministratör"
    },
    "format": {
        "bold": "Fet",
        "italic": "Kursiv",
        "underline": "Understruken",
        "alignment": "Justering",
        "alignLeft": "Justera Vänster",
        "alignCenter": "Justera Centrerad",
        "alignRight": "Justera Höger",
        "alignJustify": "Justera Marginaler",
        "list": "Lista",
        "bulletedList": "Punktlista",
        "numberedList": "Numrerad lista",
        "font": "Teckensnitt",
        "size": "Storlek",
        "fontSize": "Font Storlek",
        "openFormatMenu": "Öppna formatmenyn",
        "undo": "Ångra",
        "redo": "Gör om"
    }
}